export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Owners'
    },
    unique: [],
    sort: 'bgg.owners',
    lang: {
        name: 'BGG Owners',
        category: 'BGG',
        description: 'Number of BGG users that own this game.',
        views: ['list', 'sheet'],
    },
    filters: ['bgg.owners']
}
